import React from 'react';
import { ChannelType } from 'src/types/common/SalesChannel';
import CloneBtn from './CloneButton';
import FloatingActionsBar from './FloatingActionsBar';
import IconStyle from './IconStyle';
import MiniInfo from './MiniInfo';
import MiniShare from './MiniShare';
import PageSetting from './PageSetting';
import SEO from './SEOSetting';

const useModules = (isOnPrimaryLanguage, floatingLinkSet, type, isNative) => {
  const _miniProgramRender = () => {
    if (isOnPrimaryLanguage) {
      return (
        <React.Fragment>
          <PageSetting />
          <FloatingActionsBar linkSet={floatingLinkSet} />
          <IconStyle />
          <MiniShare />
          <MiniInfo />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <CloneBtn />
          <PageSetting hideTimeSelect />
          <FloatingActionsBar linkSet={floatingLinkSet} />
          <MiniShare />
          <MiniInfo />
        </React.Fragment>
      );
    }
  };
  const _websiteRender = () => {
    if (isOnPrimaryLanguage) {
      return (
        <React.Fragment>
          {isNative && (
            <React.Fragment>
              {' '}
              <FloatingActionsBar linkSet={floatingLinkSet} />
              <IconStyle />
            </React.Fragment>
          )}
          <PageSetting />
          <SEO />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <CloneBtn />
          {isNative && (
            <React.Fragment>
              <FloatingActionsBar linkSet={floatingLinkSet} />
            </React.Fragment>
          )}
          <PageSetting hideTimeSelect />
          <SEO hideSlug />
        </React.Fragment>
      );
    }
  };
  const renderContent = () => {
    if (type === ChannelType.MiniProgram) {
      return _miniProgramRender();
    }
    if (type === ChannelType.Website) {
      return _websiteRender();
    }
    return null;
  };
  const renderPart = React.useMemo(() => {
    return renderContent();
  }, [isOnPrimaryLanguage, type, floatingLinkSet]);
  return renderPart;
};
export default useModules;
